import { Paragraph } from '@/components/common/Typography';
import BlogLink from '@/components/goals/BlogLink';
import { FlexCol } from '../common/Flex';

const IsAmountKnownBottomContent = ({
    blogHref,
    blogLinkText,
    isAmountKnown,
}: {
    blogHref: string;
    blogLinkText: string;
    isAmountKnown: boolean | undefined;
}) => {
    return (
        <FlexCol gap={10} h={20}>
            <Paragraph fontSize="sm" color="textMuted" mt={8} h={5}>
                {isAmountKnown === false
                    ? `All good - we'll figure it out together.`
                    : undefined}
            </Paragraph>
            <BlogLink href={blogHref}>{blogLinkText}</BlogLink>
        </FlexCol>
    );
};

export default IsAmountKnownBottomContent;
